import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useContactRelationshipDrawerViewModel = () => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const createRelationship = (data) => {
    return stateManager.run(async () => {
      const { dependentType: type, label } = data;
      const response = await accountService.contactCategories.create({
        type,
        label,
        data,
        toastMessageConfig: {
          success: {
            text: `Relationship was created successfully.`,
          },
        },
      });
      return response.status === HTTP_STATUSES.OK;
    });
  };

  const updateRelationship = (data) => {
    return stateManager.run(async () => {
      const { dependentType: type, label } = data;
      const response = await accountService.contactCategories.update({
        type,
        label,
        data,
        toastMessageConfig: {
          success: {
            text: `Relationship was updated successfully.`,
          },
        },
      });
      return response.status === HTTP_STATUSES.OK;
    });
  };

  return {
    createRelationship,
    updateRelationship,
    isLoading,
  };
};

